
import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-graduation-cap-line',
    title: 'Lisans Programları',
    description: 'Almanya\'daki prestijli üniversitelerde lisans eğitimi için başvuru sürecinizi baştan sona yönetiyoruz.',
    image: 'https://public.readdy.ai/ai/img_res/03ed741a338e5823de7af2f728eb7457.jpg',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Yüksek Lisans Programları',
    description: 'Master programları için üniversite seçiminden kabul sürecine kadar profesyonel destek sağlıyoruz.',
    image: 'https://readdy.ai/api/search-image?query=graduate%20students%20in%20a%20seminar%20room%20at%20a%20prestigious%20european%20university%20discussing%20research%20papers%20modern%20academic%20environment%20professional%20master%20degree%20program%20setting&width=600&height=400&seq=svc-master-001&orientation=landscape',
  },
  {
    icon: 'ri-translate-2',
    title: 'Dil Okulu',
    description: 'A1\'den C1 seviyesine kadar Almanca dil eğitimi için en uygun dil okullarını bulmanıza yardımcı oluyoruz.',
    image: 'https://readdy.ai/api/search-image?query=language%20school%20classroom%20with%20diverse%20international%20students%20learning%20german%20language%20teacher%20at%20whiteboard%20colorful%20educational%20materials%20bright%20modern%20classroom%20setting&width=600&height=400&seq=svc-dil-001&orientation=landscape',
  },
  {
    icon: 'ri-passport-line',
    title: 'Vize Danışmanlığı',
    description: 'Öğrenci vizesi başvurusu için gerekli tüm belgeleri hazırlıyor ve süreçte yanınızda oluyoruz.',
    image: 'https://readdy.ai/api/search-image?query=professional%20visa%20consultation%20office%20with%20passport%20documents%20on%20desk%20official%20paperwork%20german%20embassy%20application%20forms%20organized%20workspace%20warm%20professional%20lighting&width=600&height=400&seq=svc-vize-001&orientation=landscape',
  },
  {
    icon: 'ri-bank-card-line',
    title: 'Bloke Hesap',
    description: 'Almanya\'da eğitim için zorunlu olan bloke hesap açılışında size rehberlik ediyoruz.',
    image: 'https://readdy.ai/api/search-image?query=modern%20banking%20and%20finance%20concept%20with%20laptop%20showing%20online%20banking%20interface%20credit%20cards%20and%20euro%20currency%20professional%20financial%20services%20clean%20desk%20setup%20warm%20lighting&width=600&height=400&seq=svc-bloke-001&orientation=landscape',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Sağlık Sigortası',
    description: 'Öğrenciler için en uygun sağlık sigortası seçeneklerini sunuyor ve işlemlerinizi kolaylaştırıyoruz.',
    image: 'https://readdy.ai/api/search-image?query=health%20insurance%20concept%20with%20medical%20stethoscope%20insurance%20documents%20and%20health%20card%20on%20a%20clean%20desk%20professional%20healthcare%20setting%20warm%20lighting%20european%20medical%20system&width=600&height=400&seq=svc-sigorta-001&orientation=landscape',
  },
  {
    icon: 'ri-home-4-line',
    title: 'Konaklama Desteği',
    description: 'Almanya\'da yurt, öğrenci evi veya daire bulmanızda size destek oluyoruz.',
    image: 'https://readdy.ai/api/search-image?query=cozy%20modern%20student%20apartment%20in%20berlin%20germany%20with%20minimalist%20furniture%20bright%20natural%20light%20city%20view%20from%20window%20comfortable%20living%20space%20warm%20tones%20european%20style%20interior&width=600&height=400&seq=svc-konak-001&orientation=landscape',
  },
  {
    icon: 'ri-plane-line',
    title: 'Havalimanı Karşılama',
    description: 'Almanya\'ya vardığınızda havalimanından konaklama yerinize kadar transfer hizmeti sağlıyoruz.',
    image: 'https://readdy.ai/api/search-image?query=airport%20arrival%20hall%20with%20welcome%20sign%20professional%20transfer%20service%20driver%20waiting%20for%20passenger%20modern%20european%20airport%20terminal%20bright%20clean%20environment&width=600&height=400&seq=svc-havalimani-001&orientation=landscape',
  },
];

export default function Services() {
  return (
    <section id="hizmetler" className="py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FFCE00]/10 rounded-full mb-4">
            <i className="ri-service-line text-[#DD0000]"></i>
            <span className="text-[#1a1a1a] text-sm font-medium">Hizmetlerimiz</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1a1a1a] mb-4">
            Size Sunduğumuz
            <span className="text-[#DD0000]"> Hizmetler</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Almanya&apos;da eğitim sürecinizin her aşamasında yanınızdayız
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <Link
              to="/services"
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-[#DD0000]/30 cursor-pointer"
            >
              {/* Image Header */}
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute top-3 left-3 w-10 h-10 rounded-lg bg-[#DD0000] flex items-center justify-center">
                  <i className={`${service.icon} text-lg text-white`}></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-5">
                <h3 className="text-lg font-bold text-[#1a1a1a] mb-2 group-hover:text-[#DD0000] transition-colors">
                  {service.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {service.description}
                </p>

                {/* Arrow */}
                <div className="mt-3 flex items-center gap-2 text-[#DD0000] opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="text-sm font-medium">Detaylı Bilgi</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
